/**
 * FaqListBlock — Rend une liste de FAQ attachées à la page CMS courante.
 * Options (d):
 *   - page_id (auto-injecté lors du rendu si présent — sinon utilise attached_faq_ids)
 *   - attached_faq_ids (optionnel) — liste explicite d'IDs pour ce bloc
 */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "../../lib/api";

export default function FaqListBlock({ d = {}, pageId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const targetPage = d.page_id || pageId;
    if (!targetPage) return;
    api.get(`/public/cms/pages/${targetPage}/faq`)
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, [d.page_id, pageId]);

  if (!items.length) {
    return <div className="border border-dashed p-4 text-sm text-ardoise/50 text-center">
      Aucune FAQ attachée à cette page. Rends-toi dans l&apos;éditeur pour en attacher.
    </div>;
  }

  return (
    <div className="space-y-3" data-testid="cms-faq-list">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: items.map((it) => ({
            "@type": "Question",
            name: it.question,
            acceptedAnswer: { "@type": "Answer", text: it.answer },
          })),
        })}</script>
      </Helmet>
      {items.map((item) => (
        <details key={item.id} className="border border-pierre bg-lin p-4 group">
          <summary className="font-serif text-lg text-domaine cursor-pointer">{item.question}</summary>
          <p className="mt-3 text-sm text-ardoise whitespace-pre-wrap">{item.answer}</p>
        </details>
      ))}
    </div>
  );
}
